import "./interface.scss";

import PropTypes from "prop-types";
import React from "react";

const Avatar = props => {
  const len = props.initials ? props.initials.length : 0;
  return (
    <span
      className={`avatar ${props.color ? props.color : ""} len${len}`}
      title={props.tooltip}
      onClick={props.onClick}
    >
      <span>{props.initials || ""}</span>
    </span>
  );
};

Avatar.propTypes = {
  image: PropTypes.string,
  initials: PropTypes.string,
  color: PropTypes.string,
  tooltip: PropTypes.string,
  onClick: PropTypes.func
};

export default Avatar;
